export enum Roles {
  DEPLOYMENT = 'DEPLOYMENT',
  EXTERNAL = 'EXTERNAL',
  ADMIN = 'ADMIN',
  SUPERADMIN = 'SUPERADMIN',
}
